import { Component, OnInit, Input } from '@angular/core';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-intl-tel-number',
  templateUrl: './intl-tel-number.component.html',
  styleUrls: ['./intl-tel-number.component.scss']
})
export class IntlTelNumberComponent implements OnInit {

  @Input()
  type: string;
  phone;
  separateDialCode = true;
	SearchCountryField = SearchCountryField;
	TooltipLabel = TooltipLabel;
	CountryISO = CountryISO;
	preferredCountries: CountryISO[] = [CountryISO.France, CountryISO.SouthAfrica];
  selectedCountry=CountryISO.France;
  constructor() { }

  ngOnInit() {
  }
  getInternationPhoneFormat(params:any){
    let intlNumber=null;
      if (params) {
        let splitted = params.split("/");
        if (splitted.length > 2) { 
        intlNumber = {
          "countryCode": splitted[0],
          "dialCode": splitted[1],
          "e164Number": splitted[1] + splitted[2],
          "internationalNumber": splitted[1] + ' ' + splitted[2],
          "nationalNumber": splitted[2],
          "number": splitted[2]
        }
        return intlNumber;
      }
    }
    return intlNumber;
  }
  setPhoneNumberfrmInternation(){
    if(this.phone){
    let intlNumber=this.phone.countryCode+ '/'+this.phone.dialCode+ '/'+this.phone.nationalNumber;
     return intlNumber;
    }
  }
  
}
